/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'ai-mate.chat-error-banner.description': 'История чата сохраняется до 30 дней.',
  'ai-mate.chat-error-banner.title': 'Начать новый чат',
  'ai-mate.chat-error.description': 'Попробуйте <btn>перезагрузить чат</btn>.',
  'ai-mate.chat-error.rate-limited-description':
    'Достигнуто максимальное количество запросов. Повторите попытку позже.',
  'ai-mate.chat-error.rate-limited-title': 'Слишком много запросов',
  'ai-mate.chat-error.rovo-inactive-description': 'Похоже, Rovo не включен на сайте. <link>Настройка Rovo</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo неактивен',
  'ai-mate.chat-error.title': 'Мы не знаем, что пошло не так',
  'ai-mate.chat-input.file-close-icon-label': 'Удалить файл',
  'ai-mate.chat-input.file-error-icon-label': 'Ошибка при загрузке файла',
  'ai-mate.chat-view.chat-item.chat-delete-label': 'Удалить',
  'ai-mate.chat-view.chat-item.chat-options-for-conversation-button-label': 'Параметры чата «{conversationName}»',
  'ai-mate.chat-view.chat-item.chat-rename-label': 'Переименовать',
  'ai-mate.common.ui.expandable-section.collapse': 'Свернуть',
  'ai-mate.common.ui.expandable-section.expand': 'Развернуть',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.cancel-button-label.non-final': 'Отмена',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.conversation-not-found-failure-message.non-final':
    'Беседа, которую вы пытаетесь удалить, не существует.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-button-label.non-final': 'Удалить',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-conversation-title.non-final':
    'Удалить беседу «{name}»?',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.generic-failure-message.non-final':
    'При удалении беседы произошла ошибка. Повторите попытку.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.modal-body.non-final':
    'Вы действительно хотите удалить эту беседу? Это действие нельзя отменить.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.cancel-button-label.non-final': 'Отмена',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.channel-not-found-error-message.non-final':
    'Канал, который вы пытаетесь отредактировать, не существует.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.edit-name-label.non-final': 'Имя',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.generic-error-message.non-final':
    'При редактировании беседы произошла ошибка. Повторите попытку.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.modal-title.non-final': 'Редактирование беседы',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.name-is-same-error-message.non-final':
    'Имя совпадает с текущим.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.save-button-label.non-final': 'Сохранить',
  'ai-mate.conversation-list-view.accessible-search-results':
    '{results, plural, one {найден {results,number} результат} few {найдено {results,number} результата} many {найдено {results,number} результатов} other {найдено {results,number} результата}}',
  'ai-mate.conversation-list-view.back-button.label': 'Назад',
  'ai-mate.conversation-list-view.close-chat-button.label': 'Закрыть чат',
  'ai-mate.conversation-list-view.header-title': 'История чата',
  'ai-mate.conversation-list-view.new-chat-button.label': 'Новый чат',
  'ai-mate.conversation-list-view.no-chat': 'Ничего не найдено',
  'ai-mate.conversation-list-view.search-input.placeholder': 'Поиск чатов',
  'ai-mate.expander.hide-details': 'Скрыть подробности',
  'ai-mate.expander.show-details': 'Развернуть',
  'ai-mate.main-chat.close-chat-panel-button-label': 'Закрыть чат',
  'ai-mate.main-chat.maximize-chat-button-label': 'На весь экран',
  'ai-mate.main-chat.minimize-chat-button-label': 'Восстановить представление',
  'ai-mate.main-chat.new-chat-button-label': 'Новое',
  'ai-mate.main-chat.new-chat-button-label-full-screen': 'Новый чат',
  'conversation-assistant-button.rovo-chat-label': 'Чат Rovo',
  'highlight-actions.rovo-chat-custom-prompt-submit-button.text': 'Отправить',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Спросите об этом AI',
  'highlight-actions.rovo-chat-explain-option.text': 'Объяснить',
  'highlight-actions.rovo-chat-explain-prompt':
    'Объясни текст. Для этого перефразируй его и добавь дополнительные сведения. Пиши очень простым языком, используй короткие предложения и приведи примеры или определения всех технических терминов из исходного текста.',
  'highlight-actions.rovo-chat-find-resources-option.text': 'Найти ресурсы',
  'highlight-actions.rovo-chat-find-resources-prompt':
    'Найди в знаниях организации ресурсы, которые подтверждают сделанные заявления.',
  'highlight-actions.rovo-chat-give-examples-option.text': 'Привести примеры',
  'highlight-actions.rovo-chat-give-examples-prompt':
    'Приведи примеры из ресурсов организации или общедоступных знаний. Если ресурсов нет, приведи метафорический пример, который поможет лучше понять суть.',
  'highlight-actions.rovo-chat-give-feedback-option.text': 'Оставить отзыв',
  'highlight-actions.rovo-chat-give-feedback-prompt':
    'Проверь формулировки и дай отзыв. Прокомментируй выбор слов, грамматику и пунктуацию. Проявляй доброжелательность и энтузиазм, но обязательно отметь хотя бы один момент, который можно улучшить или изменить.',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Рекомендации чата',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Открыть чат',
  'highlight-actions.rovo-chat-summarize-option.text': 'Создать сводку',
  'highlight-actions.rovo-chat-summarize-prompt':
    'Выдели главное. Сделай акцент важной информации и исключи ненужные детали. Дай краткий обзор в одном абзаце.',
  'highlight-actions.rovo-chat.ask-in-chat-button-text': 'Задать вопрос в чате',
  'highlight-actions.rovo-chat.placeholder-prompt': 'Задать вопрос об этом.',
  'horizontal-scroll-container.scroll-left': 'Прокрутить влево',
  'horizontal-scroll-container.scroll-right': 'Прокрутить вправо',
  'rovo-chat.deep-research-spotlight.description':
    'Включите углубленные исследования и введите запрос. Rovo разработает план, проведет исследование и подготовит подробный отчет.',
  'rovo-chat.deep-research-spotlight.dismiss': 'Закрыть',
  'rovo-chat.deep-research-spotlight.heading': 'Представляем углубленные исследования в Rovo',
  'rovo-chat.file-upload-dropzone.drag-drop-message': 'Перетащите, чтобы добавить контекст',
  'rovo-chat.message-file.icon-label': 'Файл',
  'rovo-chat.search-input.screen-reader-prompt':
    'При вводе любых символов в это поле будут обновляться результаты поиска ниже',
};
